<cx-window
    i18n-title="@@benchmark-dashboard.editor.dashboard-property.window.titel"
    title="Dashboard Properties"
    [height]="400"
    [width]="250"
    class="dashboard.editor.window"
    name="benchmark-dashboard.editor.dashboard-property.window"
    test-id="benchmark-dashboard.editor.dashboard-property.window"
>
    <div has="default-paddings">
        <clx-row has="full-size-columns big-layout">
            <clx-label i18n="@@benchmark-dashboard.editor.dashboard-properte.chart.size" >Chart size</clx-label>
            <clx-select
                [value]="storage.data().chartWidth"
                (valueChanged)="storage.set('chartWidth', $event)"
                test-id="benchmark-dashboard.properties.chart-size"
            >
                <clx-value i18n="@@general.value.auto" value="auto">Responsive</clx-value>
                <clx-value i18n="@@general.value.fixed" value="fixed">Fixed</clx-value>
            </clx-select>
        </clx-row>
        <clx-row has="full-size-columns big-layout">
            <clx-label i18n="@@benchmark-dashboard.editor.dashboard-properte.chart.labes">Show Labels</clx-label>
            <clx-checkbox
                name="showSeriesLabel"
                [ngModel]="storage.data()?.showSeriesLabel"
                (ngModelChange)="storage.set('showSeriesLabel', $event)"
            >
            </clx-checkbox>
         
        </clx-row>
    </div>
</cx-window>